var ace = require('bytelang-brace');
require('brace/ext/statusbar');
var StatusBar = ace.acequire('ace/ext/statusbar').StatusBar;

module.exports = {
	template: '<div :style="{width: width, position: position, top: top, bottom: bottom}"></div>',

	props: {
		content: {
			type: String,
			required: true
		},
		position: {
			type: String,
			default: 'absolute'
		},
		top: {
			type: String,
			default: '35px',
		},
		bottom: {
			type: String,
			default: '0px',
		},
		lang: {
			type: String,
			default: 'javascript'
		},
		theme: {
			type: String,
			default: 'chrome'
		},
		width: {
			type: String,
			default: '100%'
		},
		sync: {
			type: Boolean,
			default: true,
		},
		size: {
			type: String,
			default: '13px',
		},
		options: {
			type: Object,
			default: function(){
				return {};
			}
		}
	},

	data: function(){
		return {
			editor: null,
		};
	},

	mounted: function(){
		var vm = this;
		var lang = vm.lang;
		var theme = vm.theme;

		ace.acequire("ace/ext/language_tools");
		var editor = vm.editor = ace.edit(vm.$el);
		editor.$blockScrolling = Infinity;
		editor.getSession().setMode('ace/mode/' + lang);
		editor.setTheme('ace/theme/' + theme);
		editor.setValue(vm.content, 1);
		editor.setOptions(this.options);
		editor.setOptions({
			highlightActiveLine: true,
			highlightSelectedWord: true,
			behavioursEnabled: false,
			wrapBehavioursEnabled: false,
			useSoftTabs: true,
			enableMultiselect: true,
		});


		editor.on('change', function(){
			vm.$parent.$emit('editor-update', editor.getValue());
		});
		editor.on('focus', function(){
			vm.$parent.$emit('editor-focus', editor.getValue());
		});
		editor.getSelection().on('changeCursor', function(){
			vm.$parent.$emit('editor-cursor', editor.getValue());
		});

		window.editor = editor;

//    var statusBar = new StatusBar(editor, document.getElementById('statusBar'));
	},
	created(){
	},
	watch: {
		theme: function(newTheme){
			var vm = this;
			vm.editor.setTheme('ace/theme/' + newTheme);
		},
		lang: function(newLang){
			var vm = this;
			vm.editor.getSession().setMode('ace/mode/' + newLang);
		},
		size: function(newSize){
			var vm = this;
			vm.editor.setFontSize(newSize);
		},
		options: function(newOptions){
			var vm = this;
			vm.editor.renderer.setOptions(newOptions);
		},
		width: function(newWidth){
			setTimeout(()=>{
				window.editor !== undefined && window.editor.resize(true);
			}, 50);
		},
		top: function(newTop){
			setTimeout(()=>{
				window.editor !== undefined && window.editor.resize(true);
			}, 50);
		},
		bottom: function(newBottom){
			setTimeout(()=>{
				window.editor !== undefined && window.editor.resize(true);
			}, 50);
		},
	},
	methods: {
		GetCursorPosition(){
			return this.editor.getCursorPosition();
		},
		SetEditorContent(data){
			this.editor.setValue(data, data.length);
		}
	},
};
